import { Renderer2, RendererFactory2, Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HelpersService {
    private readonly document = inject<Document>(DOCUMENT);

    private readonly renderer: Renderer2;

    constructor() {
        const rendererFactory = inject(RendererFactory2);

        this.renderer = rendererFactory.createRenderer(null, null);
    }

    loadScript(src: string) {
        const script = this.renderer.createElement('script');
        script.type = `text/javascript`;
        script.src = src;
        this.renderer.appendChild(this.document.body, script);
        return script;
    }

    removeScript(script: HTMLScriptElement) {
        this.renderer.removeChild(this.document.body, script);
    }
}
